import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import whatInput from 'what-input';
import useClickAway from '../../utils/useClickAway';
import { getId } from '@common/utils/brandDiffsUtils';
import { t } from 'i18next';
const Tooltip = (props) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const button = useRef();
    const tootltipRef = useRef();
    const boxRef = useRef();
    const [offset, setOffset] = useState(0);
    useEffect(() => {
        setTimeout(() => {
            var _a;
            if (((_a = props === null || props === void 0 ? void 0 : props.containerRef) === null || _a === void 0 ? void 0 : _a.current) && boxRef.current) {
                let tempOffset = 0;
                tempOffset = props.containerRef.current.getBoundingClientRect().right - boxRef.current.getBoundingClientRect().right;
                if (tempOffset < 0 && tempOffset != offset) {
                    setOffset(tempOffset);
                    return;
                }
                tempOffset = props.containerRef.current.getBoundingClientRect().left - boxRef.current.getBoundingClientRect().left;
                if (tempOffset > 0 && tempOffset != offset) {
                    setOffset(tempOffset);
                }
            }
        }, 100);
    }, []);
    useEffect(() => {
        const escape = (e) => {
            if (e.key == 'Escape') {
                setShowTooltip(false);
                document.removeEventListener('keydown', escape);
            }
        };
        if (showTooltip) {
            if (whatInput.ask() == 'keyboard') {
                document.addEventListener('keydown', escape);
            }
        }
        props.setToolTipOpen && props.setToolTipOpen(showTooltip);
    }, [showTooltip]);
    const toggleOpen = () => {
        // console.info('open tooltip' + props.id);
        // if (window.innerWidth > window.mqObj.md && props.checkout) {
        //   setShowTooltip(false);
        // } else {
        setShowTooltip(!showTooltip);
        // }
        // setShowTooltip(!showTooltip);
    };
    const handleBlur = () => {
        // console.info('blur tooltip');
        setShowTooltip(false);
    };
    useClickAway(button, () => {
        // console.info('clickaway tooltip');
        setShowTooltip(false);
    });
    useEffect(() => {
        // OE-20308 - temporary fix to checkout HK and KR tooltip overflowing outside the viewport
        const tooltipElements = document.querySelectorAll('.checkout-packaging__options .tooltip__box');
        const lastTooltipElement = tooltipElements[tooltipElements.length - 1];
        if (lastTooltipElement && (window.country == 'HK' || window.country == 'KR')) {
            lastTooltipElement.classList.add('last-tooltip');
        }
    }, []);
    const renderCloseButton = () => (React.createElement("button", { "aria-label": t('button.close'), className: "tooltip__close", onClick: () => setShowTooltip(false) }, "X"));
    return (React.createElement("div", { ref: tootltipRef, className: classNames('tooltip', props.className && props.className), onBlur: (e) => {
            // console.info('blur: ', e.relatedTarget, tootltipRef.current.contains(e.relatedTarget as Node));
            if (e.relatedTarget && !tootltipRef.current.contains(e.relatedTarget) && !e.relatedTarget.matches('[aria-modal]')) {
                whatInput.ask() == 'keyboard' ? handleBlur() : undefined;
            }
        }, style: { '--tooltip-offset': `${offset}px` } },
        React.createElement("button", { type: "button", ref: button, onClick: toggleOpen, className: `icon--${props.icon ? props.icon : 'tooltip'} tooltip__button`, "aria-expanded": showTooltip, "aria-controls": props.id, "aria-label": props.ariaLabel }),
        props.text && (React.createElement(React.Fragment, null, getId() === 'ST' ? (React.createElement("div", { ref: boxRef, id: props.id, className: "tooltip__box" },
            renderCloseButton(),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: props.text } }))) : (React.createElement("div", { ref: boxRef, id: props.id, className: "tooltip__box", dangerouslySetInnerHTML: { __html: props.text } })))),
        props.markup && (React.createElement("div", { ref: boxRef, id: props.id, className: "tooltip__box" },
            getId() == 'ST' && renderCloseButton(),
            props.markup()))));
};
export default Tooltip;
